<template>
    <div class="modalPopupLayout" :class="{'active':visible}">
        <div class="documentOption contentWrap">
            <h2 class="title">문서정보</h2>
            <div class="overflow content">
                <div class="option">
                    <h3>&#183; 공개정보 설정</h3>
                    <div class="btns">

                    </div>
                    <!--v-show="apiType === 'process'"-->
                    <table>
                        <thead>
                        <tr>
                            <th>항목</th>
                            <th>정보</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="value, key in defaultData" v-if="userData[key] || activeData[key]">
                            <td>{{value.name}}</td>
                            <td>{{!userData[key]?activeData[key]:userData[key]}}</td>
                        </tr>
                        <!-- 읽기 전용이 아닌 경우 노출 -->
                        <tr v-for="value, key in userTableData">
                            <td>{{value.name}}</td>
                            <td>{{userData[key]}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="option">
                    <h3>&#183; 공저자 정보 (총 {{myCoauthors.length}}명)</h3>
                    <table>
                        <thead>
                        <th>사용자 ID</th>
                        <th>이름</th>
                        <th>권한</th>
                        </thead>
                        <tbody>
                        <tr>
                            <td>{{userData['loginId']}}</td>
                            <td>{{userData['name']}}</td>
                            <td>관리자</td>
                        </tr>
                        <tr v-for="coauthor in myCoauthors">
                            <td>{{coauthor.loginId}}</td>
                            <td>{{coauthor.name}}</td>
                            <td>공저자권한</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <button class="close" @click="close">닫기</button>
        </div>
        <Loading :visible="loading" type="fixed"/>
    </div>
</template>

<script>
import CommNew, {commNewMapMutations, commNewMapGetters} from "@processEditor/CommNew";
import Pagination from '../../common/Pagination.vue';
import BtnLink from '@components/btns/BtnLink.vue';
import TypeSelector from '@common/selects/TypeSelector';
import Loading from '@common/loading.vue';

export default {
  props: {
    apiType: {
      type: String,
      default: 'process'
    },
    ProcessId: {
      type: Number,
      default: 0
    },
    isAuth: {
      type: Boolean,
      default: false
    },
    protocolType: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      processType: "",
      visible: false,
      defaultData: {
        protocolId: {name: '프로토콜 번호', value: ''},
        loginId: {name: '사용자 ID', value: ''},
        name: {name: '이름', value: ''},
      },
      userTableData: {
        email: {name: '이메일', value: '', status: false, activeKey: 'emailActive'},
        companyName: {name: '소속(직장명)', value: '', status: false, activeKey: 'companyNameActive'},
        mobile: {name: '전화', value: '', status: false, activeKey: 'mobileActive'},
        position: {name: '직책', value: '', status: false, activeKey: 'positionActive'},
        /*researchPart: {name: '연구분야', value: '', status: false, activeKey: 'researchPartActive'},
        researchNumber: {name: '국가연구자번호', value: '', status: false, activeKey: 'researchNumberActive'},*/
      },
      userData: {},
      activeData: {},
      processDeleteAlert: false,
      Api: null,
      myCoauthors: [],
      loading: false,
      isConnectUser: false,
      isProcessAuthor: false,
    }
  },
  mixins: [CommNew],
  components: {
    Pagination,
    BtnLink,
    TypeSelector,
    Loading,
  },
  computed: {
    ...commNewMapGetters(['status',]),

    getIdType() {
      let idType = null;

      switch (this.apiType) {
        case 'process' :
          return this.$route.query.processId;
          break;
        case 'protocol' :
          this.PROCESS_INFO.protocols.map(p => {
            //if (this.$route.query.protocolId == p.id) {
            if (p.innerProtocolId == this.getInnerProtocolId) {
              idType = p.innerProtocolId;
            }
          })
          return idType;
      }
    }
  },
  watch: {
    'status.readOnlyDocumentOption': {
      // deep: true,
      // immediate: true,
      async handler(value) {
        if (value === true) this.show()
      }
    },
    /*'$route.query.protocolId': {*/
    'getInnerProtocolId': {
      async handler() {
        this.authCheck();
      },
    },
  },
  async mounted() {
    this.Api = this.$wApi[this.apiType];
    this.authCheck();
  },
  methods: {
    ...commNewMapMutations(['updateStatus']),
    async show() {
      let data = null;
      if(this.apiType == 'process'){
        data = await this.Api.optionUser.get(null, this.$route.query.processId);
      }else if(this.apiType == 'protocol'){
        data = await this.Api.optionUser.get(null, this.$route.query.protocolId);
      }
      this.userData = data.user;
      this.activeData = data;
      this.visible = true;
      this.collaboratorList();
    },
    close() {
      this.visible = false;
      this.updateStatus({'readOnlyDocumentOption': false})
    },
    async disconnectProtocol() {
      try {
        this.loading = true;
        let response = await this.$wApi.protocol.disconnectProtocolList({
          disconnectIdList: [this.getIdType],
        });
        this.loading = false;
        if (response) {
          await this.status.issueListStatus.reload();
          const path = '/process/editor';
          this.$router.replace({
            path: path,
            query: {
              processId: this.$route.query.processId,
              editorType: 'process'
            }
          });
          this.processDeleteAlert = false;
          this.close();
          this.$router.go();
        }
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },

    async collaboratorList() {
      this.loading = true;
      let res = null;
      if (this.apiType === "process") {
        res = await this.$wApi.process.collaborator.get({
          query: '',
          processId: this.$route.query.processId,
          isCollaborator: 1,
          collaboratorUserId: this.userData['loginId'],
        });
      } else if (this.apiType === "protocol") {
        res = await this.$wApi.protocol.collaborator.get({
          query: '',
          protocolId: this.activeData.protocolId,
          isCollaborator: 1,
          collaboratorUserId: this.userData['loginId'],
        });
      }
      this.myCoauthors = res;
      this.loading = false;
    },

    async authCheck() {
      if(this.apiType === "protocol") {
        //권한체크 프로토콜일 경우
        const {protocols, processType, processCollaborators, processAuthorUser} = this.PROCESS_INFO;
        this.processType = processType;
        //this.crntProtocol = protocols.filter(o => o.id == this.$route.query.protocolId)[0];
        this.crntProtocol = protocols.filter(o => o.innerProtocolId == this.getInnerProtocolId)[0];
        this.isConnectUser = false;
        this.isProcessAuthor = false;
        if (this.user.id == this.crntProtocol.innerCreateUserId) {
          this.isConnectUser = true;
        }
        if (this.user.id == processAuthorUser?.userId) {
          this.isProcessAuthor = true
        }

        if (this.processType != "ONLY_PROTOCOL") {
          processCollaborators?.forEach(item => {
            if (this.user.id == item.userId) {
              this.isProcessAuthor = true
            }
          })
        }
      }
      //process 일때 버튼 추가시 추가
      /*else if(this.apiType === "process") {
        console.log(123);
      }*/
    },
  }
}
</script>

<style lang="scss">
.modalPopupLayout {
  @include modalLayoutBlur();

  .overflow {
    height: 100%;

    .btns {
      z-index: 1;
    }
  }
}

.documentOption {
  min-width: 700px;
  padding: 24px;
  background-color: #fff;
  max-height: 90%;

  .searchInput {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-top: 30px;
    font-size: 14px;

    input {
      width: 400px;
      height: 32px;
      border-radius: 4px;
      border: 1px solid #999;
      flex-shrink: 2;
      padding: 0 50px 0 10px;
    }

    button {
      flex-shrink: 0;
      position: relative;
      left: -50px;
      width: 40px;
      height: 40px;
      font-size: 0;
      background: url('../../../assets/icons/magnify.svg') right 10px center no-repeat;
    }
  }

  .option {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;

    & + .option {
      margin-top: 62px;
    }

    h3 {
    }

    button {
      padding: 4px 8px;
      color: #666;
      background: #eee;
      font-size: 14px;
    }

    table {
      width: 100%;
      margin-top: 27px;
      font-size: 14px;
      @include text-prt-sb;

      thead {
        // border-bottom: 1px solid #000;
      }

      th {
        position: sticky;
        top: 0;
        width: auto;
        padding: 11px;
        text-align: center;
        box-shadow: inset 0 -1px 0 #333;
        background-color: #fff;
      }

      td {
        padding: 11px;
        border-bottom: 1px solid #ddd;
        text-align: center;

        input[type='checkbox'] {
          width: 20px;
          height: 20px;
          border: 2px solid #999;
          border-radius: 50%;
          appearance: none;

          &:checked {
            background: url('../../../assets/icons/icon-check-circle.svg') center no-repeat;
            border-color: #000;
          }

          cursor: pointer;
        }
      }

      tr:last-child td {
        border: 0
      }
    }
  }

  .ctrl {
    flex-wrap: wrap;
    margin-top: 30px;
  }

  .buttons {
    grid-area: ctrl;
    justify-self: center;
    padding: 24px 0 0 0;
  }

  .confirm {
    min-width: 80px;
    padding: 8px;
    border-radius: 5px;
    background-color: #4879BB;
    color: #fff;
  }

  .pagination {
    flex-shrink: 0;
    width: 100%;
  }

  .alertPopup {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    .layout {
      padding: 24px;
      border: 1px solid #999;
      background: #fff;
    }

    z-index: 5;

    .title {
      margin-bottom: 6px;
    }

    .content {
      font-size: 12px;
      line-height: 24px;
      color: #999;
    }

    .buttons-wrap {
      display: flex;
      justify-content: center;
      gap: 8px;
      margin-top: 14px;
    }
  }
}
</style>